import { jsx, Fragment } from 'react/jsx-runtime';

function EmptyMessage(props) {
  if (props.hasSearched) {
    return /*#__PURE__*/jsx(Fragment, {
      children: "Ingen besvarelser matcher din s\xF8gning"
    });
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: "Ingen besvarelser matcher din filtrering"
  });
}

export { EmptyMessage };
//# sourceMappingURL=empty-message.js.map
